import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MapsService } from '@uzurv/clara';
import { LocationSearchInputComponent } from './location-search-input/location-search-input.component';

@NgModule({
  imports: [CommonModule, FormsModule, MatInputModule, MatListModule, MatIconModule, MatButtonModule, ReactiveFormsModule],
  declarations: [LocationSearchInputComponent],
  providers: [MapsService],
  exports: [LocationSearchInputComponent]
})
export class LocationModule {}
